import { render, staticRenderFns } from "./CardUserExcludeInfo.vue?vue&type=template&id=07dccb98&scoped=true"
import script from "./CardUserExcludeInfo.vue?vue&type=script&lang=js"
export * from "./CardUserExcludeInfo.vue?vue&type=script&lang=js"
import style0 from "./CardUserExcludeInfo.vue?vue&type=style&index=0&id=07dccb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dccb98",
  null
  
)

export default component.exports